import { render, staticRenderFns } from "./SimpleNavTabs.vue?vue&type=template&id=6f16da4a&"
import script from "./SimpleNavTabs.vue?vue&type=script&lang=ts&"
export * from "./SimpleNavTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports